import { useNavigate } from "react-router-dom";
import Nav from "./Navigation.js";
import React, { useState, useEffect } from "react";

export default function Main() {
  const [buttonText, setButtonText] = useState("Have Input? Contact Me");
  // const [gamesNameOptions, setGamesNameOptions] = useState([]);
  let navigate = useNavigate();
  const handleSectionClick = (path) => {
    navigate(path);
  };

  useEffect(() => {
    const fetchDropdownOptions = async () => {
      // try {
      //   const gamesResponse = await fetch(`${process.env.REACT_APP_API_HOST}/api/games`);
      //   if (!gamesResponse.ok) {
      //     throw new Error('Failed to fetch games');
      //   }
      //   const games = await gamesResponse.json();
      //   setGamesNameOptions(games);
      // } catch (error) {
      //   console.error("Error fetching dropdown options:", error);
      // }
    };

    fetchDropdownOptions();
  }, []);

  const handleContactClick = () => {
    setButtonText("Discord Name: @ShandaDaPanda");
  };

  return (
    <div>
      <Nav />
      <div className="flex">
        {/* Sidebar */}
        {/* <div className="w-1/6 h-screen bg-black-800 text-white border border-purple-800 p-4">
          <h2 className="text-2xl mb-4 pt-24">My Item Quick Jump</h2>
          <ul>
            {gamesNameOptions.map((game) => (
              <li key={game.id} className="mb-2">
                <button
                  className="text-left w-full hover:underline"
                  onClick={() => handleSectionClick(`/myitems/${game.name}`)}
                >
                  {game.name}
                </button>
              </li>
            ))}
          </ul>
        </div> */}

        {/* Main content */}
        <div className="w-5/6 text-white p-4">
          <div className="text-center text-4xl">
            Welcome to the Unofficial Labyrinthine Tracker
          </div>
          <div className="text-center text-2xl">
            (If you have any suggestions/concerns/issues, feel free to contact me through the option below)
          </div>
          <div className="mt-8 text-center">Where do you wanna go?</div>

          <div className="flex justify-center items-center ">
            <div className="flex text-center space-x-4">
              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/statistics")}
              >
                <div className="m-4">
                  <div>ALL ITEM STATISTICS</div>
                </div>
              </div>

              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/monsters")}
              >
                <div className="m-4">
                  <div>MEET THE MONSTERS</div>
                </div>
              </div>

              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/locations")}
              >
                <div className="m-4">
                  <div>COLLECTION OF MAPS(WIP)</div>
                </div>
              </div>

              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/puzzles")}
              >
                <div className="m-4">
                  <div>FULL LIST OF PUZZLES</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center mt-4 ">
            <div className="flex text-center space-x-4">
              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/paintingSolver")}
              >
                <div className="m-4">
                  <div>PAINTING TRACKER</div>
                </div>
              </div>

              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/LightsOut")}
              >
                <div className="m-4">
                  <div>LIGHTS OUT PRACTICE</div>
                </div>
              </div>

              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/LightsOutSolver")}
              >
                <div className="m-4">
                  <div>LIGHTS OUT SOLVER </div>
                </div>
              </div>

              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/slidergame")}
              >
                <div className="m-4">
                  <div>SLIDER GAME PRACTICE</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center mt-4 ">
            <div className="flex text-center space-x-4">
              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/memory")}
              >
                <div className="m-4">
                  <div>MATCHING PUZZLE HELPER</div>
                </div>
              </div>
              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/Items")}
              >
                <div className="m-4">
                  <div>VIEW LIST OF ALL ITEMS</div>
                </div>
              </div>
              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/login")}
              >
                <div className="m-4">
                  <div>LOG ME INTO MY TRACKER</div>
                </div>
              </div>

              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={() => handleSectionClick("/signup")}
              >
                <div className="m-4">
                  <div>I WANT TO SIGN UP NOW!</div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center mt-4 ">
            <div className="flex text-center space-x-4">
              <div
                className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
                onClick={handleContactClick}
              >
                <div className="m-4">
                  <div>{buttonText}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// import { useNavigate } from "react-router-dom";
// import Nav from "./Navigation.js";
// import React, { useState } from "react";

// export default function Main() {
//   const [buttonText, setButtonText] = useState("Have Input? Contact Me");
//   let navigate = useNavigate();
//   const handleSectionClick = (path) => {
//     navigate(path);
//   };

//   const handleContactClick = () => {
//     // Add any logic you need here
//     // For example, you can change the text when the button is clicked
//     setButtonText("Discord Name: @ShandaDaPanda");
//     // You can also navigate to the specified path if needed
//     // history.push(path);
//   };
//   return (
//     <div className="text-white">
//       <Nav />
//       <div className="text-center text-4xl">
//         Welcome to the Unofficial Labyrinthine Tracker
//       </div>
//       <div className="text-center text-2xl">
//         (This Tracker is currently in alpha mode/under construction)
//       </div>
//       <div className="text-center text-2xl">
//         (Current Issues being worked on: Refresh not working with new Host site. If you need to refresh, Go to Home Page and return to your desired page!)
//       </div>
//       <div className="text-center text-2xl">
//         THANK YOU FOR YOUR PATIENCE!
//       </div>
//       <div className="text-center text-2xl">
//         (If you have any suggestions/concerns/issues, feel free to to contact me through the option below)
//       </div>
//       <div className="mt-8 text-center">Where do you wanna go?</div>

//       <div className="flex justify-center items-center ">
//         <div className="flex text-center space-x-4">
//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/statistics")}
//           >
//             <div className="m-4">
//               <div>ALL ITEM STATISTICS</div>
//             </div>
//           </div>

//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/monsters")}
//           >
//             <div className="m-4">
//               <div>MEET THE MONSTERS</div>
//             </div>
//           </div>

//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/locations")}
//           >
//             <div className="m-4">
//               <div>COLLECTION OF MAPS(WIP)</div>
//             </div>
//           </div>

//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/puzzles")}
//           >
//             <div className="m-4">
//               <div>FULL LIST OF PUZZLES</div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="flex justify-center items-center mt-4 ">
//         <div className="flex text-center space-x-4">
//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/paintingSolver")}
//           >
//             <div className="m-4">
//               <div>PAINTING TRACKER</div>
//             </div>
//           </div>

//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/LightsOut")}
//           >
//             <div className="m-4">
//               <div>LIGHTS OUT PRACTICE</div>
//             </div>
//           </div>

//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/LightsOutSolver")}
//           >
//             <div className="m-4">
//               <div>LIGHTS OUT SOLVER </div>
//             </div>
//           </div>

//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/slidergame")}
//           >
//             <div className="m-4">
//               <div>SLIDER GAME PRACTICE</div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="flex justify-center items-center mt-4 ">
//         <div className="flex text-center space-x-4">
//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/memory")}
//           >
//             <div className="m-4">
//               <div>MATCHING PUZZLE HELPER</div>
//             </div>
//           </div>
//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/Items")}
//           >
//             <div className="m-4">
//               <div>VIEW LIST OF ALL ITEMS</div>
//             </div>
//           </div>
//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/login")}
//           >
//             <div className="m-4">
//               <div>LOG ME INTO MY TRACKER</div>
//             </div>
//           </div>

//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={() => handleSectionClick("/signup")}
//           >
//             <div className="m-4">
//               <div>I WANT TO SIGN UP NOW!</div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="flex justify-center items-center mt-4 ">
//         <div className="flex text-center space-x-4">
//           <div
//             className="border-4 border-solid border-purple-950 border-x-purple-500 rounded h-20 w-40 cursor-pointer hover:bg-violet-800"
//             onClick={handleContactClick}
//           >
//             <div className="m-4">
//               <div>{buttonText}</div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
